import { GlobalApplicationState } from "globalApplicationState"
import * as actions from "./actions";

export const setMobileAppBannerOpen = (open: boolean)=> (dispatch, getState: () => GlobalApplicationState) => {
    dispatch(actions.CreateSetMobileAppBannerOpen({ open }));
}
